import { render, staticRenderFns } from "./zhuyuan_see.vue?vue&type=template&id=08c3b9da&scoped=true&"
import script from "./zhuyuan_see.vue?vue&type=script&lang=js&"
export * from "./zhuyuan_see.vue?vue&type=script&lang=js&"
import style0 from "./zhuyuan_see.vue?vue&type=style&index=0&id=08c3b9da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3b9da",
  null
  
)

export default component.exports